// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1BVWY","cell":"ColumnAccessor_cell__1Bil3","firstCellAccent":"ColumnAccessor_firstCellAccent__3kVuw"};